export function getGuideLabelTransform(percentile: number): string {
  if (percentile === 100) return 'translateX(0)';
  if (percentile === 1) return 'translateX(-100%)';
  return 'translateX(-50%)';
}
